import { render, staticRenderFns } from "./PreviewProva.vue?vue&type=template&id=89f67826&scoped=true"
import script from "./PreviewProva.vue?vue&type=script&lang=ts"
export * from "./PreviewProva.vue?vue&type=script&lang=ts"
import style0 from "./PreviewProva.vue?vue&type=style&index=0&id=89f67826&prod&lang=scss"
import style1 from "./PreviewProva.vue?vue&type=style&index=1&id=89f67826&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f67826",
  null
  
)

export default component.exports